import React from 'react';

interface PrimaryButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  type?: 'button' | 'submit' | 'reset';
  className?: string;
  disabled?: boolean;
  onClick?: () => void;
  children: React.ReactNode;
}

function PrimaryButton({
  type = 'button',
  className,
  children,
  ...props
}: PrimaryButtonProps) {
  return (
    <button
      type={type}
      className={`rounded-large bg-dodger-blue text-white text-center h-12 font-semibold focus:outline-none disabled:opacity-50 px-4 ${
        className || ''
      }`}
      {...props}
    >
      {children}
    </button>
  );
}

export default PrimaryButton;
